import React, { useState, Component, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Redirect } from "react-router-dom";
import { Divider, Icon, Link } from "@material-ui/core";

import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";

//importing files

import aboutusImg from "../../assets/images/Aboutus/boris-misevic-HofOYDPOIdA-unsplash.jpg";

// MUI Components
import {
  Grid,
  Typography,
} from "@material-ui/core";

export default function ProductDetails() {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <div>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 20, paddingBottom: 10 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} color="inherit" href="/">
            Home
          </Link>
          <Typography color="textPrimary">About us</Typography>
        </Breadcrumbs>

        <div>
          <div className={classes.imagecover}>
            <div className={classes.layer}></div>
            <div className={classes.textImageContainer}>
              <Typography
                variant="h1"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  wordSpacing: 6,
                  letterSpacing: 3,
                }}
              >
                DigiMart is Mall, marketplace and a community.
              </Typography>
            </div>
          </div>
          <div style={{ paddingTop: 50 }}>
            <Typography variant="h2" style={{ fontWeight: "bold" }}>
              Our Mission
            </Typography>
            <Typography variant="h6" style={{ paddingTop: 10, textAlign:'justify' }}>
              We started DigiMart because we wanted to give users a better
              experience of online shopping. As part of the DigiMart Group, our
              mission is to make it easy to do business anywhere. We do this by
              giving suppliers the tools necessary to reach a global audience
              for their products, and by helping buyers find products and
              suppliers quickly and efficiently.
            </Typography>
          </div>

          <div style={{ paddingTop: 50 }}>
            <Typography variant="h2" style={{ fontWeight: "bold" }}>
              One-Stop Sourcing
            </Typography>
            <Typography variant="h6" style={{ paddingTop: 10, textAlign:'justify' }}>
              DigiMart brings you hundreds of millions of products in over 40
              different major categories, including consumer electronics,
              machinery and apparel. Buyers for these products are located all
              over the country and exchange hundreds of thousands of messages
              with suppliers on the platform each day.
            </Typography>
          </div>

          <div style={{ paddingTop: 50 }}>
            <Typography variant="h2" style={{ fontWeight: "bold" }}>
              Anytime, Anywhere
            </Typography>
            <Typography variant="h6" style={{ paddingTop: 10, textAlign:'justify' }}>
              As a platform, we continue to develop services to help businesses
              do more and discover new opportunities. Whether it’s sourcing from
              your mobile phone or contacting suppliers in their local language,
              turn to Alibaba.com for all your global business needs.p
            </Typography>
          </div>
        </div>

        {/* //SERVICES */}
        <div style={{ paddingTop: 50 }}>
          <Typography variant="h2" style={{ fontWeight: "bold" }}>
            Our Services
          </Typography>
          <Grid container direction="row" className={classes.servicesBox}>
            <div className={classes.service}>
              <AirportShuttleOutlinedIcon
                className={classes.serviceIcon}
                style={{ fontSize: "65px" }}
              />
              <div className={classes.servicesTextBox}>
                <Typography
                  className={classes.serviceText}
                  style={{ fontWeight: "bold" }}
                >
                  Fast Delivery
                </Typography>
                <Typography
                  className={classes.serviceTextLight}
                  style={{ fontSize: 13 }}
                >
                  Fast Delivery on all orders
                </Typography>
              </div>
            </div>

            <div className={classes.service}>
              <AccountBalanceWalletIcon
                className={classes.serviceIcon}
                style={{ fontSize: "65px" }}
              />
              <div className={classes.servicesTextBox}>
                <Typography
                  className={classes.serviceText}
                  style={{ fontWeight: "bold" }}
                >
                  Money Return
                </Typography>
                <Typography
                  className={classes.serviceTextLight}
                  style={{ fontSize: 13 }}
                >
                  Return guarantee in 7 days
                </Typography>
              </div>
            </div>

            <div className={classes.service}>
              <LoyaltyIcon
                className={classes.serviceIcon}
                style={{ fontSize: "65px" }}
              />
              <div className={classes.servicesTextBox}>
                <Typography
                  className={classes.serviceText}
                  style={{ fontWeight: "bold" }}
                >
                  Exciting Offers
                </Typography>
                <Typography
                  className={classes.serviceTextLight}
                  style={{ fontSize: 13 }}
                >
                  Exciting deals for new users
                </Typography>
              </div>
            </div>

            <div className={classes.service}>
              <QuestionAnswerIcon
                className={classes.serviceIcon}
                style={{ fontSize: "65px" }}
              />
              <div className={classes.servicesTextBox}>
                <Typography
                  className={classes.serviceText}
                  style={{ fontWeight: "bold" }}
                >
                  Support 24/7
                </Typography>
                <Typography
                  className={classes.serviceTextLight}
                  style={{ fontSize: 13 }}
                >
                  Get Support 24 hours a day
                </Typography>
              </div>
            </div>
          </Grid>
        </div>
      </div>
    </div>
  );
}
